export default {"src":"/_next/static/media/coin_telegraph_logo.0b508a09.svg","height":56,"width":238,"blurWidth":0,"blurHeight":0};